<!--半成品  备份-->
<template>
  <div>
    <div>
      <div class="flex mb10">
        <Input placeholder="请输入" v-model.trim="filterText" clearable class="mr20" />
        <Button type="primary" class="box-content-btn" @click="searchOneTree()">查询</Button>
      </div>
      <Tree
        ref="sTree"
        :data="list"
        multiple
        :show-checkbox="true"
        @on-check-change="checkChange"
        @on-select-change="selectChange"
      ></Tree>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import tools from "@/libs/tools"
export default {
  name: "treeSelect",
  props: {
    treeList: {
      type: Array,
      default: () => [],
    },
    originList: {
      type: String,
      default: "",
    },
  },
  data () {
    return {
      list: [],
      checkedList: [], //已勾选数据列表
      checkedListIncludeParent: [], //已勾选数据的列表-包括父节点
      immNodesList: [], //获取选中及半选节点列表
      filterText: "",
    }
  },
  watch: {
    treeList: {
      deep: true,
      handler: function (val) {
        this.list = val
      },
    },
  },
  methods: {
    searchOneTree () {
      if (!this.filterText) {
        this.list = JSON.parse(this.originList)
      } else {
        this.list = tools.searchTree("name", "code", this.filterText, JSON.parse(this.originList))
      }
      this.list = tools.getCheckedTree("code", this.list, this.checkedList)
      this.$emit("update:treeList", this.list)
    },
    // 点击树节点时触发	当前已选中的节点数组、当前项
    selectChange () {
      // selected为true的数据
      let nodes0 = this.$refs.sTree.getSelectedNodes()
      console.log(nodes0)
    },
    checkChange (s, curr) {
      let immNodes = this.$refs.sTree.getCheckedAndIndeterminateNodes()
      immNodes.forEach((item) => {
        this.immNodesList.push(item)
      })
      this.immNodesList = tools.duplicateList(this.immNodesList, "id")
      let unCheckedIdList = tools.getUnCheckedList(
        [curr],
        "checked",
        "id",
        []
      )
      let nodes = this.$refs.sTree.getCheckedNodes()
      nodes.forEach((item) => {
        this.checkedListIncludeParent.push(item)
      })
      this.checkedListIncludeParent = tools.duplicateList(
        this.checkedListIncludeParent,
        "id"
      )
      let l = nodes.filter((item) => !item.children)
      l.forEach((item) => {
        this.checkedList.push(item)
      })
      this.checkedList = tools.duplicateList(this.checkedList, "id")
      if (unCheckedIdList.length) {
        this.immNodesList = this.deleteAll(this.immNodesList, unCheckedIdList)
        this.checkedList = this.deleteAll(this.checkedList, unCheckedIdList)
        this.checkedListIncludeParent = this.deleteAll(
          this.checkedListIncludeParent,
          unCheckedIdList
        )
      }
      this.$emit(
        "on-check-change",
        s,
        curr,
        this.checkedList,
        this.checkedListIncludeParent,
        this.immNodesList
      )
    },
    /**
     * 数组-删除所有满足条件的数据
     */
    deleteAll (data, e) {
      let len = data.length
      while (len--) {
        if (e.includes(data[len].id)) {
          data.splice(len, 1)
        }
      }
      return data
    },
  },
};
</script>

<style lang="less" scoped>
</style>
